import React from 'react'
import { FormControl, RadioGroup } from '@mui/material';

import { IEvaluacion } from '../constants';
import Divider from '../../Divider';
import FControlLabel from '../../shared/Forms/FControlLabel';



interface Props {
  dataEvaluacion: IEvaluacion;
  handleChange(type: string, value: string | number): void;
}

const SedeEntreno = ({ dataEvaluacion, handleChange }: Props) => {
  return (
    <div>
      <div className='text-center'>
        <h2 className="title font-bold mb-2">
          ¿Donde entrenarás en este nuevo mes?
        </h2>
        <p className="text-slate-500">Seleccione donde realizará sus entrenamientos</p>
        <Divider type="option" />
      </div>

        <div className="row">

          <div className="col-12 text-start">
            <FormControl>
              <RadioGroup
                aria-labelledby="demo-radio-buttons-group-label"
                defaultValue="1"
                name="radio-buttons-group"
                value={ dataEvaluacion.sedeID }
                onChange={(ev) => {
                  handleChange( 'sedeID', ev.target.value );
                }}
                >
                <FControlLabel
                  value="22"
                  size='1.15rem'
                  label="En casa"
                  fontWeight={500}
                  />
            
                <FControlLabel value="10" size='1.15rem' label="En Gimnasio" fontWeight={500} />

              </RadioGroup>
            </FormControl>
          </div>

        </div>
    </div>
  )
}

export default SedeEntreno